import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Grid} from '@material-ui/core';
import {VisibilityOff as InvisibleIcon, Visibility as VisibleIcon} from '@material-ui/icons';

const VisiblePassword = ({password}) => {
  const [visible, setVisible] = useState(false);
  return (
    <Grid container spacing={2} justify="space-between" alignItems="center">
      <Grid item xs={7}>
        {visible ? <span className="wrap-word">{password}</span> : '********'}
      </Grid>
      <Grid item xs={5} className="cursor-pointer">
        {visible ? (
          <InvisibleIcon onClick={() => setVisible(false)} />
        ) : (
          <VisibleIcon onClick={() => setVisible(true)} />
        )}
      </Grid>
    </Grid>
  );
};

VisiblePassword.propTypes = {
  password: PropTypes.string,
};

export default VisiblePassword;
